<div class="fn-payment-details-modal" *ngIf="detailsArray.length > 0">
  <div class="" id="modalToPDF">
    <div class="fn-payment-details-modal__header">
      <div class="fn-payment-details-modal__title">
        <div>Detalle de pago</div>
      </div>

      <div class="fn-payment-details-modal__close">
        <div
          class="fn-payment-details-modal__close-label"
          *ngIf="!data.isConsolidatedEdited"
        >
          <span class="fn-payment-details-modal__close-label__txt"
            >ID Consolidado:</span
          >
          <span class="fn-payment-details-modal__close-label__value">{{
            data.idConsolidate || idConsolidate || data.idConsolidated
          }}</span>
        </div>
        <img
          src="../../../../../../assets/new-styles/icons/buttons/close-icon.svg"
          mat-dialog-close
          class="fn-payment-details-modal__close__icon{{
            data.isConsolidatedEdited ? '-conso' : ''
          }}"
        />
      </div>
    </div>

    <div class="fn-payment-details-modal__detail">
      <div *ngFor="let val of detailsArray">
        <div
          *ngFor="let a of val"
          class="fn-payment-details-modal__detail-group"
        >
          <div class="fn-payment-details-modal__detail-group-key">
            {{ a.key }}: 
          </div>
          <div
            class="fn-payment-details-modal__detail-group-value{{
              isAmountKey(a.key) ? '__amount' : ''
            }}"
          >
            {{ isAmountKey(a.key) ? "$" : ""
            }}{{ isAmountKey(a.key) ? [a.value | amount] : a.value === true ? 'Si' : a.value === false ? 'No' : a.value ?? '-' }}
          </div>
        </div>
      </div>
    </div>
    <div class="fn-payment-details-modal__invoices" id="modalToPDF">
      <table
        class="fn-payment-details-modal__invoices_table"
        *ngIf="selectedInvoices.length > 0 && cardMobiles === false"
      >
        <thead class="fn-payment-details-modal__invoices_table__head">
          <tr>
            <th class="fn-payment-details-modal__invoices_table__head-first">
              {{
                "IP.PAYMENTS.DETAILS.INVOICES_TABLE.INVOICENUMBER" | translate
              }}
            </th>
            <th>
              {{ "IP.PAYMENTS.DETAILS.INVOICES_TABLE.PERIOD" | translate }}
            </th>
            <th>
              {{ "IP.PAYMENTS.DETAILS.INVOICES_TABLE.DUEDATE" | translate }}
            </th>
            <th>
              {{ "IP.PAYMENTS.DETAILS.INVOICES_TABLE.DESCRIPTION" | translate }}
            </th>
            <th
              class="fn-payment-details-modal__invoices_table__head{{
                data.isConsolidatedEdited ? '' : '-last'
              }}"
            >
              {{ "IP.PAYMENTS.DETAILS.INVOICES_TABLE.AMOUNT" | translate }}
            </th>
            <!-- <th *ngIf="data.isConsolidatedEdited">Seleccionar</th> -->
          </tr>
        </thead>
        <tbody
          class="fn-payment-details-modal__invoices_table__body"
          *ngIf="!data.isConsolidatedEdited && cardMobiles === false"
        >
          <tr *ngFor="let item of selectedInvoices">
            <td class="fn-payment-details-modal__invoices_table__body-first">
              {{ item.invoiceId || item.invoiceNumber }}
            </td>
            <td>{{ formatDateToMonthYearIntl(item.creationDate) }}</td>
            <td>{{ item.dueDate | customDate }}</td>
            <td>{{ item.description || "-" }}</td>
            <td class="fn-payment-details-modal__invoices_table__body-last">
              ${{ item.amount | amount }}
            </td>
            <td *ngIf="data.isConsolidatedEdited" style="text-align: center">
              <input
                type="checkbox"
                [checked]="isItemSelected(item)"
                (change)="toggleItemSelection(item)"
              />
            </td>
          </tr>
        </tbody>
        <tbody
          class="fn-payment-details-modal__invoices_table__body"
          *ngIf="data.isConsolidatedEdited && cardMobiles === false"
        >
          <tr *ngFor="let item of data.info.invoices">
            <td class="fn-payment-details-modal__invoices_table__body-first">
              {{ item.invoiceId || item.invoiceNumber }}
            </td>
            <td>{{ formatDateToMonthYearIntl(item.creationDate) }}</td>
            <td>{{ item.dueDate | customDate }}</td>
            <td>{{ item.description || "-" }}</td>
            <td class="fn-payment-details-modal__invoices_table__body-last">
              ${{ item.amount | amount }}
            </td>
            <!-- <td *ngIf="data.isConsolidatedEdited" style="text-align: center">
              <input
                type="checkbox"
                [checked]="isItemSelected(item)"
                (change)="toggleItemSelection(item)"
              />
            </td> -->
          </tr>
        </tbody>
      </table>
      <div class="fn-payment-details-modal__invoices-card" *ngIf="cardMobiles">
        <div class="fn-payment-details-modal__invoices-card-title">
          {{ "IP.PAYMENTS.DETAILS.INVOICES" | translate }}
        </div>
        <div
          class="fn-payment-details-modal__invoices-card-data"
          *ngFor="let val of invoicesListCard"
        >
          <div *ngFor="let a of val">
            <div class="fn-payment-details-modal__invoices-card__group">
              <div class="fn-payment-details-modal__invoices-card__group-key">
                {{ a.key }}
              </div>
              <div
                class="fn-payment-details-modal__invoices-card__group-value{{
                  isAmountKey(a.key) ? '__amount' : ''
                }}"
              >
                {{ isAmountKey(a.key) ? "$" : ""
                }}{{
                  isAmountKey(a.key)
                    ? [a.value | amount]
                    : a.key === "Período"
                    ? formatDateToMonthYearIntl(a.value)
                    : a.key === "Vencimiento"
                    ? [a.value | customDate]
                    : a.value
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fn-payment-details-modal__btn">
    <button
      class="fn-payment-details-modal__btn-download"
      *ngIf="!data.isConsolidatedEdited && idConsolidate"
      (click)="downloadPayDetails()"
    >
      <img
        src="../../../../../../assets/new-styles/icons/buttons/download-icon.svg"
        alt=""
      />{{ "IP.PAYMENTS.DETAILS.DOWNLOAD" | translate }}
    </button>
    <button
      class="fn-payment-details-modal__btn-close"
      mat-dialog-close
    >
      {{ "IP.PAYMENTS.DETAILS.CLOSE" | translate }}
    </button>
    <!-- <button
      *ngIf="data.isConsolidatedEdited"
      class="fn-payment-details-modal__btn-close"
      (click)="saveSelectedItems()"
      mat-dialog-close
    >
      Guardar
    </button> -->
  </div>
</div>
